export default __webpack_public_path__ + "static/media/REBIRTH 3D.8fcfdbd2.mp4";